import styled from "@emotion/styled";

export const AcknowledgementLinePreviewContainer = styled.div(({ theme }) => ({
	border: theme.project.borders.presets.outline,
	padding: "4px",
	width: "max-content",
	"& > img": {
		width: "100%"
	},
	[theme.breakpoints.down("sm")]: {
		display: "none"
	}
}));
